import {
    getFullName,
    isAdmin as userIsAdmin,
    isAgency as userIsAgency,
    isContact as userIsContact,
    isNormalUser as userIsNormalUser,
    isRealtor as userIsRealtor,
    storeUser
} from "@models/user";
import {logout} from "@models/auth";

import {axios} from '@http_client';
import cookie from "react-cookies";
import User from "../../models/user";

export const initial_state = {
        check: false,
        user: new User(),
        getName: '',
        isRealtor: false,
        isAgency: false,
        isAdmin: false,
        isContact: false,
        isNormalUser: true,
        contacts: function () {
            return {
                mobile: this.user.mobile,
                mobile2: this.user.mobile2,
                phone1: this.user.phone1,
                phone2: this.user.phone2,
                phone3: this.user.phone3,
                phone4: this.user.phone4,
            }
        },
        modality: {
            type: '',
            city_id: '',
            city_name: '',
            show_invest: false,
            show_invest_modal: false,
            position: 'drawer',
        }
    }
;

export const UserReducer = (state, action) => {
    switch (action.type) {
        case 'STORE_USER' :
            const {token, user, storeTokenInCookie} = action.payload;

            storeUser(token, user, storeTokenInCookie);
            const getName = getFullName(user);
            const isRealtor = userIsRealtor(user);
            const isAgency = userIsAgency(user);
            const isAdmin = userIsAdmin(user);
            const isContact = userIsContact(user);
            const isNormalUser = userIsNormalUser(user);

            if (process.browser) {
                const token = cookie.load('auth_token');
                if (token) {
                    axios.defaults.headers.common['Auth-Token'] = token
                }
            }

            return {
                ...state,
                check: true,
                user: user,
                getName: getName,
                isRealtor: isRealtor,
                isAgency: isAgency,
                isAdmin: isAdmin,
                isContact: isContact,
                isNormalUser: isNormalUser,
            };
        case 'LOGOUT' :
            logout();

            return {
                ...state,
                check: false,
                user: {},
                getName: '',
                isRealtor: false,
                isAgency: false,
                isAdmin: false,
                isContact: false,
                isNormalUser: true,
            };

        case 'MODALITY' :
            return {
                ...state,
                modality: action.payload
            }
    }
};